import { tv } from 'tailwind-variants'

import { listboxStyles } from '@gto/ui/styles/listbox-styles'

export const autocompleteVariants = tv({
  slots: {
    positioner: listboxStyles.positioner,
    popup: listboxStyles.popup,
    // `data-[empty]:p-0` so a popup showing only `Empty` is not double-padded by
    // the list wrapper it no longer fills.
    list: [...listboxStyles.list, 'data-[empty]:p-0'],
    group: listboxStyles.group,
    groupLabel: listboxStyles.groupLabel,
    item: listboxStyles.item,
    empty: 'px-2 py-1.5 text-sm text-text-secondary',
    clear:
      'flex cursor-pointer items-center border-none bg-transparent p-0 text-text-secondary hover:text-text-primary',
  },
})
